import React, { useEffect, useState } from "react";
import "./OrdersView.css";
import { toastr } from "react-redux-toastr";
import { toast } from "react-toastify";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment-timezone";
import { Button, Modal, Form, Table } from "react-bootstrap";
import { Dialog, DialogContent, DialogTitle, Box } from "@mui/material";
import { CloseIcon } from "@mui/icons-material";
import LoadingSpinner from "../../Loading/component";
import profile from "../../../assests/gprofile.svg";
import Avatar from "../../../assests/Avatar.png";
import infoIcon from "../../../assests/infoIcon.svg";
import phone1 from "../../../assests/phone11.svg";
import mail from "../../../assests/mail.svg";
import dateTime from "../../../assests/dateTime.svg";
import city from "../../../assests/city.svg";
import kiosk from "../../../assests/kiosk.svg";
import vm from "../../../assests/vm.svg";
import leftArrow from "../../../assests/leftArrow.svg";
import itemDetails from "../../../assests/itemDetails.svg";
import refund from "../../../assests/refund.svg";
import success from "../../../assests/success.svg";
import cross from "../../../assests/cross.svg";
import panding from "../../../assests/panding.svg";
import cancel from "../../../assests/cancel.svg";
import refundSucessIcon from "../../../assests/refundSuccessIcon.gif";
import upi from "../../../assests/upi.svg";
import indicator from "../../../assests/indictor.svg";
import refundNotreq from "../../../assests/refundNotreq.svg";
import emptyCircleIcon from "../../../assests/emptyCircleIcon.svg";
import refund_upon from "../../../assests/refund_upon.svg";
import refundschdulesuccess from "../../../assests/refundschdulesuccess.svg";
import notrequired from "../../../assests/notrequired.svg";
import refund_success from "../../../assests/refund_success.svg";
import failedrefundicon from "../../../assests/failedrefundicon.svg";
import checkIconGreen from "../../../assests/checkIconGreen.svg";
import walletIcon from "../../../assests/walletIcon.svg";
import bankcard from "../../../assests/bankcard.svg";
import recevied from "../../../assests/recevied.svg"

const statusConfig = {
  REFUND_UPON_REQUEST: {
    icon: refund_upon,
    color: "#F28618",
    message: "If the customer did not receive any product, verify and initiate a manual refund.",
    exeptedSatlementMsg: "Expected Settlement Time: once Refund confirm (refund schedule time + 60 minutes)",
    successMSG: "Refund will be processed to your payment source"
  },
  REFUND_SCHEDULED: {
    icon: refundschdulesuccess,
    color: "#14AE78",
    message: " Your refund has been successfully scheduled and will be initiated in 40mins.",
    exeptedSatlementMsg: "Expected Settlement Time: once Refund confirm (refund schedule time + 60 minutes)",
    successMSG: "Refund will be processed to your payment source ."
  },
  // REFUND_PROCESSING: {
  //   icon: refundSucessIcon,
  //   color: "#FFC107",
  //   message: "Your refund is being processed by the bank.",
  // },
  REFUND_SUCCESSFUL: {
    icon: refund_success,
    color: "#14AE78",
    message: "Refund reference number is 12345678",
    successMSG: "Refund successfully credited to your payment source."
  },
  REFUND_INITIATION_FAILED: {
    icon: notrequired,
    color: "#DC3545",
    message: "kindly refund manually or ask admin to refund by a payment gateway dashboards.",
    successMSG: "Refund will be processed to your payment source.",
    exceptedSTimer: "Expected Settlement Time: after initiation  ",
  },
  REFUND_NOT_REQUIRED: {
    icon: refundNotreq,
    color: "#DC3545",
    message: "If customer has any concern, kindly ask for product image and then initiate manual refund.",
    successMSG: "Refund will be processed to your payment source.",
    exceptedSTimer: "Expected Settlement Time: after initiation  ",
  },
  REFUND_INITIATED: {
    icon: checkIconGreen,
    color: "#DC3545",
    message: " If customer has any concern, kindly ask for product image and then initiate manual refund .",
    successMSG: "Refund will be processed to your payment source.",
    exceptedSTimer: "Expected settlement time(refund initiation time + 60 min or value returned by API) ",
  },
  REFUND_FAILED: {
    icon: failedrefundicon,
    color: "#DC3545",
    message: " refund could not be processed due to a technical issue.",
    successMSG: "Refund will be processed to your payment source.",
    exceptedSTimer: "Expected settlement time(refund initiation time + 60 min or value returned by API) ",
  },
};

export const OrdersViewComp = ({
  data,
  loading,
  show,
  handleClose,
  handleShow,
  handleSubmit,
  issue,
  handleIssueChange,
  selectedIssue,
  handleIssueTextChange,
  handleCopyInfo,
  orderStatus,
  fetchOrderStatus,
}) => {
  const refundDetails = orderStatus || [];
  const [showDetails, setShowDetails] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(null);
  const [remainingTime, setRemainingTime] = useState(0);
  const [dialogData, setDialogData] = useState(null);
  const navigate = useNavigate();
  const { orderid, pg_name } = useParams();

  const handleOpenStatusModal = (orderId, refundAmount, pgName, resultStatus, resultMsg) => {
    setDialogData({
      orderId,
      refundAmount,
      pgName,
      resultStatus,
      resultMsg
    });
    setShowStatusModal(true);
    fetchOrderStatus();
  };

  const handleCloseStatusModal = () => setShowStatusModal(false);

  useEffect(() => {
    if (data?.created_at) {
      const createdTime = moment(data.created_at);
      const currentTime = moment();
      const maxAllowedTimeInSeconds = 35 * 60;
      const timeDifferenceInSeconds = currentTime.diff(createdTime, "seconds");
      const remainingTimeInSeconds = maxAllowedTimeInSeconds - timeDifferenceInSeconds;

      if (remainingTimeInSeconds > 0) {
        setRemainingTime(remainingTimeInSeconds);
        const timer = setInterval(() => {
          setRemainingTime(prev => prev - 1);
        }, 1000);
        return () => clearInterval(timer);
      }
    }
  }, [data]);

  const minutes = Math.floor(remainingTime / 60);
  const seconds = remainingTime % 60;

  const handleShowDetails = () => setShowDetails(true);

  const arrowClick = (event) => {
    event.preventDefault();
    navigate("/home/ordersview");
  };

  // const handleInitiateRefund = () => {
  //   const pg_name = data?.payment_details&& data?.payment_details?.pg_name !== "null" ? data.payment_details.pg_name : "";
  //   navigate(`/home/orderview/manualrefund/${pg_name}/${data?.id}/${data?.source}`);
  // };

  const handleInitiateRefund = () => {
  const pg_name = data?.payment_details && data?.payment_details?.pg_name !== "null"
    ? data.payment_details.pg_name
    : "";
  const id = data?.id;
  const source = data?.source;

  if (!pg_name || !id || !source) {
    toast.error("Refund cannot be initiated. Required information is missing!");
    return;
  }

  navigate(`/home/orderview/manualrefund/${pg_name}/${id}/${source}`);
};

  if (loading) return <LoadingSpinner />;

  return (
    <div className="orders-view-container">
      <Sidebar />
      
      <div className="orders-view-content">
        <div className="orders-view-header">
          <button onClick={arrowClick} className="back-button">
            <img src={leftArrow} alt="Back" />
          </button>
          <div>
            <h1>Mini Order ID: {data?.dcCode}</h1>
            <h5>Order ID: {data?.id}</h5>
          </div>
          <div className="order-status">
            <span>{data?.status}</span>
          </div>
          <div className="header-buttons">
            <Button variant="primary" onClick={handleShow}>Copy Details</Button>
            <Button variant="success" onClick={handleInitiateRefund}>Initiate Refund</Button>
          </div>
        </div>

        <div className="order-sections-container">
          {/* Customer Details Section */}
          <div className="customer-details-section">
            <div className="order-section-header">
              <img src={profile} alt="" />
              <p>Customer Details</p>
            </div>
            <div className="customer-card">
              <div className="customer-avatar">
                <img src={Avatar} alt="Customer" />
                <p>{data?.user_details?.name}</p>
              </div>
              <div className="customer-info">
                <div className="info-row">
                  <img src={phone1} alt="Phone" />
                  <p>{data?.phone}</p>
                </div>
                <div className="info-row">
                  <img src={mail} alt="Email" />
                  <p>{data?.user_details?.email}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Order Information Section */}
          <div className="order-info-section">
            <div className="order-info-section-header">
              <div style={{display:"flex"}}>
              <img src={infoIcon} alt="" />
              <p>Order Information</p>
              </div>
              <Button onClick={handleCopyInfo}>Copy Info</Button>
            </div>
            <div className="order-info-grid">
              <div className="info-column">
                <div className="info-row">
                  <img src={dateTime} alt="Date" />
                  <p>Date & Time: {moment.utc(data?.created_at).tz("Asia/Kolkata").format("YYYY-MM-DD hh:mm:ss A")}</p>
                </div>
                <div className="info-row">
                  <img src={city} alt="City" />
                  <p>City: {data?.city}</p>
                </div>
                <div className="info-row">
                  <img src={city} alt="Address" />
                  <p>VM Address: {data?.vmAddress}</p>
                </div>
              </div>
              <div className="info-column">
                <div className="info-row">
                  <img src={kiosk} alt="Source" />
                  <p>Order Via: {data?.source}</p>
                </div>
                <div className="info-row">
                  <img src={vm} alt="VM" />
                  <p>VM Name: {data?.name}</p>
                </div>
                <div className="info-row">
                  <img src={vm} alt="VM ID" />
                  <p>VM ID: {data?.machine_id}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Items Details Section */}
        <div className="items-details-section">
          <div className="order-section-header">
            <img src={itemDetails} alt="" />
            <p>Items Details</p>
          </div>
          <div className="items-table-container">
            <Table responsive>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Slot Number</th>
                  <th>MRP</th>
                  <th>Offer Price</th>
                  <th>Quantity</th>
                  <th>Total</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.line_items?.map(item => (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.slot_id}</td>
                    <td>{item.mrp}</td>
                    <td>{item.offer_price}</td>
                    <td>{item.item_count}</td>
                    <td>{item.sub_total}</td>
                    <td>
                      {item.success_count > 0 && (
                        <><span>{item.success_count}</span> <img src={success} alt="Success" /></>
                      )}
                      {item.failure_count > 0 && (
                        <><span>{item.failure_count}</span> <img src={cross} alt="Failure" /></>
                      )}
                      {item.vend_remaining_count > 0 && (
                        <><span>{item.vend_remaining_count}</span> <img src={panding} alt="Pending" /></>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Payment Details Section */}
        <div className="payment-details-section">
          <div className="order-payment-section-header">
            <div style={{display:"flex"}}>
              <img src={refund} alt="" />
              <p>Payment Details</p>
            </div>
            <Button variant="outline-success" onClick={() => handleOpenStatusModal()}>
              Check Refund Status
            </Button>
          </div>
          <div className="payment-card">
            <div className="payment-amount">
              <h3 className="order-amount-text">₹ {data?.amount}</h3>
            </div>
            {/* <div className="logoRefund">
                          <h3>₹ {data && data.amount}</h3>
                        </div> */}

            <div className="payment-info-grid">
              <div>
                <p className="info-label">ID</p>
                <p>{data?.payment_details?.id}</p>
              </div>
              <div>
                <p className="info-label">Status</p>
                <p>{data?.payment_details?.status}</p>
              </div>
              <div>
                <p className="info-label">Date & Time</p>
                <p>{moment.utc(data?.payment_details?.updated_at).tz("Asia/Kolkata").format("YYYY-MM-DD hh:mm:ss A")}</p>
              </div>
              <div>
                <p className="info-label">Payments Gateway</p>
                <p>{data?.payment_details?.pg_name}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Refund Status Dialog */}
        <Dialog open={showStatusModal} onClose={handleCloseStatusModal} className="refund-status-dialog">
          <DialogTitle className="dialog-header">
            <p>Refund status</p>
            <button onClick={handleCloseStatusModal}>
              <img src={cancel} alt="Close" />
            </button>
          </DialogTitle>
          <DialogContent className="dialog-content">
            {loading ? (
              <LoadingSpinner />
            ) : (
              <Box className="refund-status-container">
                {refundDetails?.refundDetailInfoList?.length > 0 ? (
                  refundDetails.refundDetailInfoList.map((refund, index) => {
                    const isStepperView = ["REFUND_INITIATED", "REFUND_SUCCESSFUL"].includes(refund.status);
                    const status = statusConfig[refund.status] || statusConfig.DEFAULT;

                    return (
                      <div className="refund-card" key={index}>
                        <p className="order-id">Order ID: <span>{refundDetails.orderId || "N/A"}</span></p>

                        {isStepperView ? (
                          <div className="stepper-view">
                            <div className="status-step">
                              <img src={checkIconGreen} alt="Confirmed" />
                              <div>
                                <p className="step-title">Refund Initiated</p>
                                <p className="step-time">
                                  {moment.utc(refund.refundInitiatedTime).local().format("D MMM YYYY, h:mm A")}
                                </p>
                              </div>
                            </div>
                            <div className="status-step">
                              <img src={refund.status === "REFUND_SUCCESSFUL" ? checkIconGreen : emptyCircleIcon} alt="Status" />
                              <div>
                                {refund.status === "REFUND_SUCCESSFUL" ? (
                                  <>
                                    <p className="step-title success">Refund Successful</p>
                                    <p className="step-time success">
                                      {moment.utc(refund.refundCreditTime).local().format("D MMM YYYY, h:mm A")}
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <p className="step-title">Refund Processing By Bank</p>
                                    <p className="step-time">
                                      Expected settlement time:{" "}
                                      {refund.refundCreditExpectedTime ? (
                                        moment.utc(refund.refundCreditExpectedTime).local().format("D MMM YYYY, h:mm A")
                                      ) : (
                                        "Refund initiation time + 60 min"
                                      )}
                                    </p>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="status-view">
                            <div className="status-icon">
                              <img src={status.icon} alt="Status" />
                            </div>
                            <p className="status-text" style={{ color: status.color }}>
                              {refund.status.replaceAll("_", " ")}
                            </p>
                            <p className="status-message">
                              <img src={indicator} alt="Indicator" /> {status.message}
                            </p>
                          </div>
                        )}

                        <div className="order-info-card">
                          <p className="info-text">
                            Paid Amount: <span>₹ {refund.paidAmount || "N/A"}</span>
                          </p>
                          <p className="info-subtext">
                            {refund.paymentTime ? moment.utc(refund.paymentTime).local().format("MMM D, YYYY, h:mm A") : "N/A"}
                          </p>
                          <p className="info-subtext">
                            Transaction ID: {refund.transactionId || "N/A"}
                          </p>
                          <hr />

                          {refund.status !== "REFUND_NOT_REQUIRED" && (
                            <>
                              <p className="info-text">
                                {refund.status === "REFUND_FAILED" ? "Refund Failed Amount" : "Refund Amount"}:
                                <span>₹ {refund.refundAmount || "N/A"}</span>
                              </p>
                              {/* Additional refund info rendering */}
                              <hr />
                            </>
                          )}

                          {!["REFUND_INITIATION_FAILED", "REFUND_FAILED", "REFUND_NOT_REQUIRED"].includes(refund.status) && (
                            <>
                              <p className="info-text">
                                Payment Method:
                                <img
                                  src={
                                    refund.payMethod?.toLowerCase() === "upi" ? upi :
                                    refund.payMethod?.toLowerCase() === "wallet" ? walletIcon : bankcard
                                  }
                                  alt={refund.payMethod}
                                />
                                {" "}{refund.payMethod ? refund.payMethod.toUpperCase() : "N/A"}
                              </p>
                              <p className="info-subtext">{status.successMSG}</p>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="no-data">No refund details available.</p>
                )}
              </Box>
            )}
          </DialogContent>
        </Dialog>

        <Modal show={show} onHide={handleClose} className="copy-details-modal">
          <Modal.Body>
            <Form>
              <Form.Group controlId="customerIssues">
                <Form.Label>Customer issues:</Form.Label>
                <Form.Select
                  value={selectedIssue}
                  onChange={handleIssueChange}
                >
                  <option value="">-- Select --</option>
                  <option value="Vending Failed">Vending Failed</option>
                  <option value="Product got stuck">Product got stuck</option>
                  {/* Other options */}
                  <option value="other">Other</option>
                </Form.Select>
                {selectedIssue === "other" && (
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={issue}
                    onChange={handleIssueTextChange}
                  />
                )}
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Close</Button>
            <Button variant="primary" onClick={handleSubmit}>Copy Details</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};